import { render, staticRenderFns } from "./HoneyMoons.vue?vue&type=template&id=3651f422&"
import script from "./HoneyMoons.vue?vue&type=script&lang=js&"
export * from "./HoneyMoons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports